import { render, staticRenderFns } from "./OrderNewAttachDialog.vue?vue&type=template&id=2a75a7e0&"
import script from "./OrderNewAttachDialog.vue?vue&type=script&lang=js&"
export * from "./OrderNewAttachDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports